import { Form, Input, Select, Space } from "antd";
import LabelWithRadio from "@/components/LabelWithRadio";

interface SetupAppraisalBenefitProps {
  prefix: string; // e.g. 'incentive' | 'increment'
}

const SetupAppraisalBenefit = ({ prefix }: SetupAppraisalBenefitProps) => {
  const form = Form.useFormInstance();
  const benefitType = Form.useWatch(`${prefix}_type`, form);

  const isPercentage = benefitType === "PERCENTAGE";

  const resetValueFields = () => {
    form.resetFields([`${prefix}_value`, `${prefix}_base`]);
  };

  return (
    <div className="w-full">
      <LabelWithRadio
        label="Benefit Setup"
        name={`${prefix}_type`}
        initialValue="FLAT"
        onRadioChange={resetValueFields}
        options={[
          { label: "Flat", value: "FLAT" },
          { label: "%", value: "PERCENTAGE" },
        ]}
      />

      {isPercentage ? (
        <Space.Compact className="compact-select w-full items-center border border-theme-slate-700 rounded-md pr-1 mt-2">
          <Form.Item
            name={`${prefix}_value`}
            noStyle
            rules={[
              { required: true, message: "Please enter percentage" },
              {
                validator: (_, value) => {
                  if (value && isNaN(Number(value)))
                    return Promise.reject(new Error("Enter numbers only"));
                  if (value && Number(value) < 1)
                    return Promise.reject(new Error("Min 1%"));
                  if (value && Number(value) > 100)
                    return Promise.reject(new Error("Max 100%"));
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              autoComplete="off"
              placeholder="00"
              suffix="%"
              className="!border-0 !bg-transparent w-full"
            />
          </Form.Item>
          <Form.Item
            name={`${prefix}_base`}
            noStyle
            rules={[{ required: true, message: "Please select component" }]}
          >
            <Select
              size="small"
              placeholder="Select component"
              className="!w-[160px]"
              placement="bottomRight"
              options={[
                { value: "BASIC", label: "Basic" },
                { value: "GROSS", label: "Gross" },
              ]}
            />
          </Form.Item>
        </Space.Compact>
      ) : (
        <Form.Item
          name={`${prefix}_value`}
          noStyle
          rules={[
            { required: true, message: "Please enter amount" },
            {
              validator: (_, value) => {
                if (value && isNaN(Number(value)))
                  return Promise.reject(new Error("Enter numbers only"));
                if (value && Number(value) < 1)
                  return Promise.reject(new Error("Min value is 1"));
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            autoComplete="off"
            prefix="BDT"
            placeholder="00"
            className="mt-2"
          />
        </Form.Item>
      )}
    </div>
  );
};

export default SetupAppraisalBenefit;
